import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { mockDocuments } from '../data/mockData';
import '../styles/HistoryPage.css';

const HistoryPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="history-page">
      <h1>{t('history')}</h1>
      <div className="history-list">
        {mockDocuments.map((doc) => (
          <div key={doc.id} className="history-item">
            <div className="history-date">{doc.date}</div>
            <div className="history-info">
              <div>{doc.issuedBy} → {doc.issuedTo}</div>
              <div className="history-file">{doc.fileName}</div>
              <div className={`history-status status-${doc.status}`}>
                {t(doc.status)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HistoryPage;
